// extracted by mini-css-extract-plugin
export default {"criticalThinking_title":"oAyT7wg4MklTFxmoOX5e","criticalThinking_text":"HBiLuxeK6j10ZJXDyV5d","scoreBarCriticalThinking__wrapper":"Q5NR6LkBQngIS3KUXrGv"};